require("packs/link_tracker")
require("packs/bookmarks")
import { createPopper } from '@popperjs/core';
import "stylesheets/discussions";
import { setEvents } from "packs/bookmarks";
import Swiper from 'swiper';
import { Navigation, Pagination, FreeMode } from 'swiper/modules';
import { fetchAPI } from "packs/api";
window.Swiper = Swiper; // Assign Swiper to the window object to make it globally accessible
Swiper.use([Navigation, Pagination, FreeMode]); // So that swiper can use pagination - without it we cannot use

document.addEventListener("DOMContentLoaded", () => {
  var loading = false;
  var page = 2;
  window.addEventListener('scroll', function() {
    const paginationEl = document.getElementById("append_pagination");
    const hasMore = paginationEl?.dataset.hasMore !== 'false';
    
    if (!loading && hasMore && isElementInViewport(paginationEl)) {
      loading = true;
      document.getElementById("pagination-animation").classList.remove("hidden");
      var params = new URLSearchParams(window.location.search);
      var paramsObject = {page: page}
      for (const [key, value] of params) {
          paramsObject[key] = value;
      }
      var url = window.location.href.split('?')[0];
      fetchAPI(url, "GET", paramsObject, "script").then(response => {
        const updatedPaginationEl = document.getElementById("append_pagination");
        const stillHasMore = updatedPaginationEl?.dataset.hasMore !== 'false';
        
        if (stillHasMore) {
          page += 1;
        }
        loading = false;
        document.getElementById("pagination-animation").classList.add("hidden");
        setEvents();
        card_click();
        setTimeout(recalculateHeight, 100);
      }).catch(error => {
        loading = false;
        document.getElementById("pagination-animation").classList.add("hidden");
      });
    }
  });

  function isElementInViewport(el) {
    if (!el || el.style.display === 'none') {
      return false;
    }
    
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function recalculateHeight() {
    document.documentElement.scrollHeight;
  }

  let swiperOfferSlider = new Swiper('.test-swiper', {
    spaceBetween: window.innerWidth < 768 ? 0 : 10,
    slidesPerView: 3,
    freeMode: true,
    loop: true,
    allowTouchMove: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: `.swiper-button-next`,
      prevEl: `.swiper-button-prev`,
    },
    breakpoints: {
      // When window width is <= 768px
      340: {
        slidesPerView: 1.5,
        pagination: false
      },
      380: {
        slidesPerView: 1.6,
        pagination: false
      },
      400: {
        slidesPerView: 1.8,
        pagination: false
      },
      768: {
        slidesPerView: 3,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      }
    },
    onInit: function(swiperOfferSlider){
      if (swiperOfferSlider.slides.length < 5) {
        const swiperContainer = document.querySelector(".test-swiper");
        if (swiperContainer) {
          const nextButton = swiperContainer.querySelector(".swiper-button-next");
          const prevButton = swiperContainer.querySelector(".swiper-button-prev");
          if (nextButton) nextButton.style.display = "none";
          if (prevButton) prevButton.style.display = "none";
        } 
      }    
    },
    onResize: function(swiperOfferSlider) {
      swiperOfferSlider.update(); // Update Swiper instance on resize
    }
  });

  let discuss_read_more = document.getElementById('discuss-read-more');
  discuss_read_more?.addEventListener('click', function(){
    let discuss_content =  document.querySelector('.discuss-content');
    discuss_content.classList.toggle('line-clamp-2');

    if (discuss_content.classList.contains('line-clamp-2')) {
      discuss_read_more.textContent = '...'+ I18n.t("read_more");
    } else {
      discuss_read_more.textContent = I18n.t("less");;
    }
  });

  function changeCardView(view) {
    let currentUrl = new URL(window.location.href);
    let displayViewParam = 'display_view';
    let displayViewValue = view;
    currentUrl.searchParams.set(displayViewParam, displayViewValue);
    window.location.href = currentUrl;
  }
  document.querySelectorAll('.change-display-view').forEach(display => {
    display.addEventListener('click', function() {
      changeCardView(this.dataset.view);
    });
  })

  // Locked discussions tooltip logic
  const button = document.querySelector('#locked-button');
  const tooltip = document.querySelector('#locked-tooltip');
  if (button && tooltip) {
    let popperInstance = createPopper(button, tooltip, {
      placement: 'top-start',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 8],
          },
        },
      ],
    });
    function popperTooltipShow() {
      tooltip.setAttribute('data-show', '');
    
      // We need to tell Popper to update the tooltip position
      // after we show the tooltip, otherwise it will be incorrect
      popperInstance.update();
    }
    
    function popperTooltipHide() {
      tooltip.removeAttribute('data-show');
    }
    
    const showEvents = ['mouseenter', 'focus'];
    const hideEvents = ['mouseleave', 'blur'];
    
    showEvents.forEach((event) => {
      button.addEventListener(event, popperTooltipShow);
    });
    
    hideEvents.forEach((event) => {
      button.addEventListener(event, popperTooltipHide);
    });
  }

  // Locked discussions tooltip logic - END  
});